/**
 * @module app.cd
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { openGlobalModal, IModalData, IDialogOptions } from 'app/shared/elements/ess-global-modal';
import * as CD from 'app/cd/models/essette-api';
import { guid } from 'app/shared/lib/guid';


@autoinject()
export class ClaimSummary extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull
    protected claim: CD.Claim | null = null;

    protected id: guid = guid();

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    /// This is for use with the global Modal passed in with the compose element
    protected async activate(model: CD.Claim): Promise<void> {
        if(!model) { return; }

        this.claim = model;
    }

    ////****************** Events ***************************************************////



    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}

/**
 * Opens the claim summary modal with the global dialog
 * @param claim The claim information to use
 */
export function openClaimSummary(claim: CD.Claim): void {
    if(!claim || !claim.id) {
        throw new Error('Claim is missing or invalid');
    }

    const dialogOptions: IDialogOptions = {
        width: '10',
        height: '10',
        helpTopic: 'cd.claim-summary',
        title: {
            key: 'cd:routes.claim.summary.$title',
            replace: { display: claim.$display }
        },
        print: true,
        popout: {
            route: 'cd.claim.summary',
            params: { claimId: claim.id }
        }
    };

    const modalData: IModalData = {
        componentId: 'app/cd/components/summary/claim/claim-summary',
        modelData: claim,
        dialogOptions: dialogOptions
    };

    openGlobalModal(modalData);
}
